import type { ExtractedField, FieldOption } from "../../types"
import { resolveSelectValue } from "../../utils/invoiceFieldHelpers"
import { EditableSelectField, type EditableSelectOption } from "./EditableSelectField"

interface MetadataSelectFieldProps {
  field: ExtractedField
  options: FieldOption[]
  placeholder: string
  editableFieldAttr: Record<string, string>
  focusTargetAttr: Record<string, string>
  onSelectChange: (field: ExtractedField, value: string) => void
  disabled?: boolean
}

const normalizeOptions = (options: FieldOption[]): EditableSelectOption[] => {
  const seen = new Set<string>()

  return options.reduce<EditableSelectOption[]>((acc, option, index) => {
    const value = option.value ?? option.label ?? `option-${index}`
    if (seen.has(value)) {
      return acc
    }
    seen.add(value)
    acc.push({
      value,
      label: option.label || option.value || value
    })
    return acc
  }, [])
}

export const MetadataSelectField = ({
  field,
  options,
  placeholder,
  editableFieldAttr,
  focusTargetAttr,
  onSelectChange,
  disabled
}: MetadataSelectFieldProps): JSX.Element => {
  if (options.length === 0) {
    return (
      <span className="text-sm text-neutral-400 italic px-1 py-1">
        Изберете клиент за опции
      </span>
    )
  }

  const normalizedOptions = normalizeOptions(options)

  return (
    <EditableSelectField
      value={resolveSelectValue(field.field_value, options)}
      placeholder={placeholder}
      options={normalizedOptions}
      onChange={(value) => onSelectChange(field, value)}
      editableFieldAttr={editableFieldAttr}
      focusTargetAttr={focusTargetAttr}
      disabled={disabled}
    />
  )
}
